const createMark = name => {
  return {
    name
  };
};
export default createMark;